import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { SEASONS } from '@app/entities/enums/manage-vacations/manage-vacations.enum';
import { ManageVacationsCriteria } from '@app/entities/models/manage-vacations/manage-vacations-criteria.model';
import { EmployeeObservations, SeasonCalendar } from '@app/entities/models/manage-vacations/manage-vacations.model';
import { MomoManageVacationsProposals } from '@app/entities/models/manage-vacations/momo-manage-vacations.model';
import { TUserTypeCalendarProposal } from '@app/entities/types/manage-vacations.type';

export interface MomoManageVacationsRepository {
  getProposals(): Observable<MomoManageVacationsProposals>;
  getVacationsCriteria(): Observable<ManageVacationsCriteria>;
  getSeasonCalendar(season: SEASONS): Observable<SeasonCalendar<TUserTypeCalendarProposal>>;
  createProposal(proposals: MomoManageVacationsProposals): Observable<MomoManageVacationsProposals>;
  updateObservations(observations: string): Observable<EmployeeObservations>;
}
export const MOMO_MANAGE_VACATIONS_REPOSITORY = new InjectionToken<MomoManageVacationsRepository>(
  'MOMO_MANAGE_VACATIONS_REPOSITORY'
);
